
  export default {
    middleware: ['blog/article', 'blog/related-product', 'breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      disableJumbotron: true,
      hasAmp: true,
      showNewsletterSignup: true
    },
    head () {
      return {
        meta: [this.article.deindexed ? { name: 'robots', content: 'noindex' } : {}]
      };
    },
    computed: {
      article () {
        return this.$store.getters['blog/getArticle'];
      }
    }
  };
